import {ERROR_SEND_EMAIL, RESET_CONTACT_BY_EMAIL, SEND_EMAIL} from "../actions/actionsContactByEmail";

const initialState = {
    response: undefined,
    errorSendEmail: undefined
};

export function reducerContactByEmail(state = initialState, action) {
    switch (action.type) {
        case SEND_EMAIL:
            // console.log("reducerContactByEmail::reducerContactByEmail() -> SEND_EMAIL");
            return {...state, response: action.payload};
        case ERROR_SEND_EMAIL:
            // console.log("reducerContactByEmail::reducerContactByEmail() -> ERROR_SEND_EMAIL");
            return {...state, errorSendEmail: action.payload.errorSendEmail};
        case RESET_CONTACT_BY_EMAIL:
            // console.log("reducerContactByEmail::reducerContactByEmail() -> RESET_CONTACT_BY_EMAIL");
            return initialState;

        default:
            return state
    }
}